import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as html2canvas from "html2canvas";
import {
  NbWindowService,
  NbWindowState,
  NbDialogService,
} from "@nebular/theme";
import { FlussoService } from "../../../../@core/api/flusso.service";
import { Flusso } from "../../../../@core/data/flusso";
import { Router } from "@angular/router";
import { ConfirmDialogComponent } from "../../../utils/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "ngx-flusso-row",
  templateUrl: "./flusso-row.component.html",
  styleUrls: ["./flusso-row.component.scss"],
})
export class FlussoRowComponent implements OnInit {
  @Input() flusso: Flusso;
  @Output() updateList = new EventEmitter();

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private flussoService: FlussoService
  ) {}

  async ngOnInit() {}

  show(type) {
    switch (type) {
      case "preview":
        window
          .open("https://flusso.elds.it/" + this.flusso.id, "_blank")
          .focus();
        break;
      case "edit":
        this.router.navigate(["home", "flusso", this.flusso.id]);
        break;
      case "copy":
        this.copyFlusso();
        break;

      case "delete":
        this.dialogService
          .open(ConfirmDialogComponent, {
            context: { operation: "eliminare " + this.flusso.name },
          })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteFlusso();
            }
          });
        break;
    }
  }

  async copyFlusso() {
    let res = <any>await this.flussoService.duplicateFlusso(this.flusso.id);
    this.updateList.emit();
  }

  async showCode() {}

  async DeleteFlusso() {
    await this.flussoService.deleteFlusso(this.flusso.id);
    this.updateList.emit();
  }

  async toggleFlusso() {
    let flusso = this.flusso;

    let res = <any>await this.flussoService.editFlusso(flusso, flusso.id);
    this.updateList.emit();
  }
}

function downloadURI(dataurl, filename) {
  const link = document.createElement("a");
  link.href = dataurl;
  link.download = filename;
  link.click();
}
